/**
 * @module cercaliagl/view/VNavBar
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from 'jquery';
import BaseView, { EventType as BaseViewEventType } from './BaseView';
import { createUid, isMobile } from '../util';
import VWidgetSearch, { EventType as WidgetSearchEventType } from './VWidgetSearch';
import VWidgetRouting, { EventType as WidgetRoutingEventType } from './VWidgetRouting';
import VWidgetPois, { EventType as WidgetPoisEventType } from './VWidgetPois';
/**
 * @enum {string}
 */
export var EventType = {
    ADDRESS: 'address',
    ROUTING: 'routing',
    POIS: 'pois',
    RESET: 'reset',
    MORE: 'more',
    CLOSE_MORE: 'close_more',
};
/**
 * @enum {string}
 */
export var View = {
    NAVBAR: 'navbar',
    ADDRESS: 'address',
    ROUTING: 'routing',
    POIS: 'pois',
};
/**
 * @type {Object.<string, string>}
 */
export var Buttons = {
    /**
     * @api
     */
    ADDRESS: 'navMenu',
    /**
     * @api
     */
    POIS: 'navPois',
    /**
     * @api
     */
    ROUTING: 'navRouting',
    /**
     * @api
     */
    MORE: 'navMore',
    /**
     * @api
     */
    CLOSE_MORE: 'navCloseMore',
};
/**
 * @classdesc
 */
var VNavBar = /** @class */ (function (_super) {
    __extends(VNavBar, _super);
    /**
     * @constructor
     */
    function VNavBar() {
        var _this = this;
        var uid = createUid();
        var autocompleteId = "navBarAutocomplete".concat(uid);
        var jqElement = $("<div class=\"v-navbar mdc-elevation--z4\">\n        <div id=\"".concat(autocompleteId, "\"></div>\n        <div class=\"mbl-more-btns\">\n          <button type=\"button\" class=\"mdc-icon-button ").concat(Buttons.MORE, " more\">\n            <span class=\"mdc-icon-button__icon icon-more-vert\"></span>\n          </button>\n          <button type=\"button\" class=\"mdc-icon-button ").concat(Buttons.CLOSE_MORE, " close-more\">\n            <span class=\"mdc-icon-button__icon icon-close\"></span>\n          </button>\n        </div>\n        <div class=\"mbl-floating-btns\">\n          <button type=\"button\" class=\"mdc-icon-button ").concat(Buttons.ADDRESS, " mdc-elevation--z4\">\n            <span class=\"mdc-icon-button__icon icon-menu\"></span>\n          </button>\n          <button type=\"button\" class=\"mdc-icon-button ").concat(Buttons.ROUTING, " mdc-elevation--z4\">\n            <span class=\"mdc-icon-button__icon icon-routing\"></span>\n          </button>\n          <button type=\"button\" class=\"mdc-icon-button ").concat(Buttons.POIS, " mdc-elevation--z4\">\n            <span class=\"mdc-icon-button__icon icon-poi\"></span>\n          </button>\n        </div>\n        <div class=\"btns\">\n          <button type=\"button\" class=\"mdc-icon-button ").concat(Buttons.ADDRESS, "\">\n            <span class=\"mdc-icon-button__icon icon-menu\"></span>\n          </button>\n          <button type=\"button\" class=\"mdc-icon-button ").concat(Buttons.ROUTING, "\">\n            <span class=\"mdc-icon-button__icon icon-routing\"></span>\n          </button>\n          <button type=\"button\" class=\"mdc-icon-button ").concat(Buttons.POIS, "\">\n            <span class=\"mdc-icon-button__icon icon-poi\"></span>\n          </button>\n        </div>\n       </div>"));
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {string}
         */
        _this.autocompleteId_ = autocompleteId;
        /**
         * @private
         * @type {VWidgetSearch}
         */
        _this.widgetSearch_ = new VWidgetSearch();
        /**
         * @private
         * @type {VWidgetRouting}
         */
        _this.widgetRouting_ = new VWidgetRouting();
        /**
         * @private
         * @type {VWidgetPois}
         */
        _this.widgetPois_ = new VWidgetPois();
        /**
         * @private
         * @type {string}
         */
        _this.currentView_ = View.NAVBAR;
        _this.initialize_();
        return _this;
    }
    /**
     * @private
     */
    VNavBar.prototype.initialize_ = function () {
        var _this = this;
        this.jqElement_.find(".".concat(Buttons.ADDRESS)).click(function () { return _this.showAdressMenu(); });
        this.jqElement_.find(".".concat(Buttons.ROUTING)).click(function () { return _this.showRoutingMenu(); });
        this.jqElement_.find(".".concat(Buttons.POIS)).click(function () { return _this.showPoisMenu(); });
        this.jqElement_.find(".".concat(Buttons.MORE)).click(function () { return _this.toggleMoreButtons(true); });
        this.jqElement_.find(".".concat(Buttons.CLOSE_MORE)).click(function () { return _this.toggleMoreButtons(false); });
        this.widgetSearch_.hide();
        this.widgetRouting_.hide();
        this.widgetPois_.hide();
        this.on(BaseViewEventType.ATTACHED, function (parentElement) {
            _this.widgetSearch_.appendTo(parentElement);
            _this.widgetRouting_.appendTo(parentElement);
            _this.widgetPois_.appendTo(parentElement);
            _this.widgetSearch_.on(WidgetSearchEventType.CLOSE_MENU, function () { return _this.reset(); });
            _this.widgetRouting_.on(WidgetRoutingEventType.CLOSE_ROUTING, function () { return _this.reset(); });
            _this.widgetPois_.on(WidgetPoisEventType.CLOSE_POIS, function () { return _this.reset(); });
        });
    };
    /**
     * Resize autocomplete input
     */
    VNavBar.prototype.adjustByDevice = function () {
        this.jqElement_.find('.v-autocomplete input').width(!isMobile() ? null : this.getMapViewport().offsetWidth - 42);
    };
    /**
     * Reset view
     */
    VNavBar.prototype.reset = function () {
        this.widgetRouting_.hide();
        this.widgetPois_.hide();
        this.widgetSearch_.hide();
        this.jqElement_.show();
        this.currentView_ = View.NAVBAR;
        this.emit(EventType.RESET);
    };
    /**
     * @param {string} button Button
     */
    VNavBar.prototype.showButton = function (button) {
        this.jqElement_.find(".".concat(button)).show();
    };
    /**
     * @param {string} button Button
     */
    VNavBar.prototype.hideButton = function (button) {
        this.jqElement_.find(".".concat(button)).hide();
    };
    /**
     * @return {VWidgetSearch} Widget search
     */
    VNavBar.prototype.getWidgetSearch = function () {
        return this.widgetSearch_;
    };
    /**
     * @return {VWidgetRouting} Widget routing
     */
    VNavBar.prototype.getWidgetRouting = function () {
        return this.widgetRouting_;
    };
    /**
     * @return {VWidgetPois} Widget POIs
     */
    VNavBar.prototype.getWidgetPois = function () {
        return this.widgetPois_;
    };
    /**
     * @return {string} autocomplete
     */
    VNavBar.prototype.getAutocompleteId = function () {
        return this.autocompleteId_;
    };
    /**
     * Show address menu
     */
    VNavBar.prototype.showAdressMenu = function () {
        this.jqElement_.hide();
        this.widgetRouting_.hide();
        this.widgetPois_.hide();
        this.widgetSearch_.show();
        this.emit(EventType.ADDRESS);
        this.currentView_ = View.ADDRESS;
    };
    /**
     * Show routing menu
     */
    VNavBar.prototype.showRoutingMenu = function () {
        this.jqElement_.hide();
        this.widgetSearch_.hide();
        this.widgetPois_.hide();
        this.widgetRouting_.toggleSettings(false);
        this.widgetRouting_.show();
        this.emit(EventType.ROUTING);
        this.currentView_ = View.ROUTING;
    };
    /**
     * Show pois menu
     */
    VNavBar.prototype.showPoisMenu = function () {
        this.jqElement_.hide();
        this.widgetSearch_.hide();
        this.widgetRouting_.hide();
        this.widgetPois_.show();
        this.emit(EventType.POIS);
        this.currentView_ = View.POIS;
    };
    /**
     * @param {boolean} visible Visible
     */
    VNavBar.prototype.toggleMoreButtons = function (visible) {
        if (visible) {
            this.jqElement_.find(".".concat(Buttons.MORE)).hide();
            this.jqElement_.find(".".concat(Buttons.CLOSE_MORE)).show();
            this.jqElement_.find('.mbl-floating-btns').show();
        }
        else {
            this.jqElement_.find(".".concat(Buttons.CLOSE_MORE)).hide();
            this.jqElement_.find(".".concat(Buttons.MORE)).show();
            this.jqElement_.find('.mbl-floating-btns').hide();
        }
    };
    /**
     * @return {string} Current view
     */
    VNavBar.prototype.getCurrentView = function () {
        return this.currentView_;
    };
    return VNavBar;
}(BaseView));
export default VNavBar;
//# sourceMappingURL=VNavBar.js.map